<template>
    <div class="nettdoc-disclaimer">
        <h2 class="nettdoc-header nettdoc-disclaimer__header">{{ $t('Disclaimer') }}</h2>
        <p class="nettdoc-disclaimer__text">
            {{ $t('disclaimerText') }}
        </p>

        <label class="nettdoc-disclaimer__checkbox">
            {{ $t('I have read and accept the terms and conditions.')+'*' }}
            <input type="checkbox" :checked="store.disclaimerAccepted" @change="toggleDisclaimerStatus" />
            <span class="nettdoc-disclaimer__checkbox--checkmark"/>
        </label>

        <div class="nettdoc-disclaimer__menu">
            <p>
              <span
                @click="$router.push(`/${$i18n.locale}/nettdoctor`)"
              >
                {{ $t('Cancel') }}
              </span>
            </p>
            <p>
              <span 
                :style="!store.disclaimerAccepted ? 'opacity:0.2;cursor:not-allowed' : ''"
                @click="acceptAndContinue"
              >
                {{ $t('Continue') }}
              </span>
            </p>
        </div>
    </div>
</template>

<script>
import { observer } from "mobx-vue";
import store from "../store/store";

export default observer({
  name: 'Disclaimer',
  data() {
      return {
          store: store
      }
  },
  beforeCreate() {
      store.persistDisclaimer()
  },
  methods: {
      acceptAndContinue: function() {
          if (store.disclaimerAccepted) {
              this.$router.push(`/${this.$i18n.locale}/nettdoctor/basicinformation`)
          }
      },
      toggleDisclaimerStatus: function() {
          store.disclaimerAccepted = !store.disclaimerAccepted
          localStorage.setItem("disclaimerAccepted", store.disclaimerAccepted)
      }
  }
})
</script>

<style lang="scss" scoped>
    .nettdoc-disclaimer {
        position: absolute;
        background-color: #ffffff;
        padding: 0 10px;
        text-align: left;
        &__header {
            margin: 0;
            padding: 36px 0 17px 0;
            font-size: 26px;
            font-weight: 500;
            color: var(--charcoal-grey);
        }
        &__text {
            margin: 0;
            font-size: 16px;
        }

        &__checkbox {
            margin-top: 32px;
            display: block;
            position: relative;
            padding-left: 35px;
            margin-bottom: 19px;
            cursor: pointer;
            font-size: 16px;
            font-weight: bold;
            color: var(--charcoal-grey);
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                height: 0;
                width: 0;
                &:checked {
                    ~ .nettdoc-disclaimer__checkbox--checkmark {
                        background: url('../assets/checkbox-check.svg');
                    }
                }
            }
            &--checkmark {
                position: absolute;
                top: -2px;
                left: 0;
                height: 24px;
                width: 24px;
                background: url('../assets/checkbox-null.svg');
            }
            &:focus {
                input ~ .nettdoc-disclaimer__checkbox--checkmark {
                    background: url('../assets/checkbox-focus.svg');
                }
            }
        }

        &__menu {
            display: grid;
            grid-template-columns: 50% 50%;
            border-top: 1px solid #d8d8d8;
            span {
                font-size: 16px;
                font-weight: bold;
                text-transform: uppercase;
                color: var(--charcoal-grey);
                cursor: pointer;
            }
            p:first-child {
                text-align: left;
            }
            p:last-child {
                text-align: right;
            }
        }
    }
</style>